export default class StaticShipRepo {
  getShips(ships, service) {
    console.log("StaticShipRepo-getShips");
    service.addNewShipFromRepo(ships, "1", {
      name: "name 1",
      requiredEEXI: 1,
      shipType: "tipo1",
    });
    service.addNewShipFromRepo(ships, "2", {
      name: "name 2",
      requiredEEXI: 2,
      shipType: "tipo2",
    });
    service.addNewShipFromRepo(ships, "3", {
      name: "name 3",
      requiredEEXI: 3,
      shipType: "tipo2",
    });
  }

  saveShip(ships, ship, service) {
    service.modifyShipFromRepo(ships, ship.id, ship);
  }
}
